import {
  StyleType,
  CssColor,
  CssFont,
} from '@wix/editor-platform-ooi-metadata-resolver';

import {
  StyleParamType,
  wixColorParam,
  wixFontParam,
  createStylesParams,
} from '@wix/tpa-settings';

export enum PresetSettings {
  FILL_STYLE,
  LABEL_STYLE,
}

export type IStylesParams = {
  textFont: StyleParamType.Font;
  _buttonColor: StyleParamType.Color;
  _btnBackgroundColor: StyleParamType.Color;
  _buttonFont: StyleParamType.Font;
  _fileIconColor2: StyleParamType.Color;
  _fileIconColor: StyleParamType.Color;
  _fileIconColorLabeled: StyleParamType.Color;
  _fileIconColor2Labeled: StyleParamType.Color;
  _fileIconColorLine: StyleParamType.Color;
  _folderFont: StyleParamType.Font;
  _textFont: StyleParamType.Font;
  _textFont1: StyleParamType.Font;
  _textColor: StyleParamType.Color;
  _hoverAndActionstableColor: StyleParamType.Color;
  _backgroundColor: StyleParamType.Color;
  _fileAndFolderColor: StyleParamType.Color;
  _buttonsAndActionsColor: StyleParamType.Color;
  _itemHoverColor: StyleParamType.Color;
  _titleFont: StyleParamType.Font;
  _pageDescriptionFont: StyleParamType.Font;
  _subTabsFont: StyleParamType.Font;
  _columnsAndItemsFont: StyleParamType.Font;
  _itemsNamesFont: StyleParamType.Font;
  _membersBgColor: StyleParamType.Color;
  _membersBorderColor: StyleParamType.Color;
  _membersBorderWidth: StyleParamType.Number;
  borderColor: StyleParamType.Color;
  borderWidth: StyleParamType.Number;
  showFileSize: StyleParamType.Boolean;
  showLastModified: StyleParamType.Boolean;
  showViewsCounter: StyleParamType.Boolean;
  showFavoritesCounter: StyleParamType.Boolean;
  showFileOwnerName: StyleParamType.Boolean;
  presetSettings: StyleParamType.Number;
};

export default createStylesParams<IStylesParams>({
  showFileSize: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      ai: {
        description: 'Show file size',
      },
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  textFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 20,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: CssFont.WstParagraph2Font,
        size: 20,
      },
    },
  },

  _buttonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-fill-background-primary'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstPrimaryBackgroundColor,
      },
    },
  },
  _btnBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstButtonPrimaryBackgroundColor,
      },
    },
  },
  _buttonFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 20,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: CssFont.WstParagraph2Font,
        size: 20,
      },
    },
  },
  _fileIconColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstLinksAndActionsColor,
      },
    },
  },
  _fileIconColor2: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstLinksAndActionsColor,
      },
    },
  },
  _fileIconColorLabeled: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstLinksAndActionsColor,
      },
    },
  },
  _fileIconColor2Labeled: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstParagraph2Color,
      },
    },
  },
  _fileIconColorLine: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstParagraph2Color,
      },
    },
  },

  _folderFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: CssFont.WstParagraph2Font,
        size: 16,
      },
    },
  },
  _textFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: CssFont.WstParagraph2Font,
        size: 14,
      },
    },
  },
  _textFont1: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: CssFont.WstParagraph2Font,
        size: 16,
      },
    },
  },
  _textColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstParagraph2Color,
      },
    },
  },
  _hoverAndActionstableColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary', 0.02),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstParagraph2Color,
        opacity: 0.02,
      },
    },
  },
  _backgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-fill-background-primary'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstPrimaryBackgroundColor,
      },
    },
  },
  _fileAndFolderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstLinksAndActionsColor,
      },
    },
  },
  _buttonsAndActionsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstLinksAndActionsColor,
      },
    },
  },
  _itemHoverColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary', 0.02),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstParagraph2Color,
        opacity: 0.02,
      },
    },
  },
  _titleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Heading-M', {
      size: 26,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: CssFont.WstHeading3Font,
        size: 26,
      },
    },
  },
  _pageDescriptionFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: CssFont.WstParagraph2Font,
        size: 16,
      },
    },
  },
  _subTabsFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: CssFont.WstParagraph2Font,
        size: 16,
      },
    },
  },
  _columnsAndItemsFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: CssFont.WstParagraph2Font,
        size: 14,
      },
    },
  },
  _itemsNamesFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: CssFont.WstParagraph2Font,
        size: 16,
      },
    },
  },
  _membersBgColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-fill-background-primary'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstPrimaryBackgroundColor,
      },
    },
  },
  _membersBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstParagraph2Color,
      },
    },
  },
  _membersBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  borderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstParagraph2Color,
      },
    },
  },
  borderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  showLastModified: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      ai: {
        description: 'Show last modified',
      },
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showViewsCounter: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      ai: {
        description: 'Show views counter',
      },
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showFavoritesCounter: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      ai: {
        description: 'Show favorites counter',
      },
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showFileOwnerName: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      ai: {
        description: 'Show file owner name',
      },
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  presetSettings: {
    type: StyleParamType.Number,
    key: 'presetSettings',
    getDefaultValue: () => PresetSettings.FILL_STYLE,
    metadata: {
      ai: {
        description:
          'DefaultValue:0; OPTIONS=[FILL_STYLE=0,LABEL_STYLE=1]; Determines the file icon style. FILL_STYLE displays filled colored icons, LABEL_STYLE displays extension label icons.',
      },
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: PresetSettings.FILL_STYLE,
      },
    },
  },
});
